angular.module('dashboard').factory('DashboardService',
    ['DashboardRepository',
        function(DashboardRepository) {
            'use strict';

            var loadPatientDashboardFeatures = function () {
                return DashboardRepository
                    .patientDashboardFeatures()
                    .then(function (repositorySettings) {
                        var localSettings = DashboardRepository.getDashboardFeatureList();
                        if (!localSettings) {
                            DashboardRepository.setDashboardFeatureList(repositorySettings);
                        }
                        else {
                            var updatedRepositorySettings = _(repositorySettings)
                                .forEach(function (repositoryItem) {
                                    var localSettingsItem = _.find(localSettings, {Id: repositoryItem.Id});
                                    if (localSettingsItem) {
                                        repositoryItem.IsCollapsed = localSettingsItem.IsCollapsed;
                                    }
                                });

                            DashboardRepository.setDashboardFeatureList(updatedRepositorySettings);
                        }
                    });
            };

            var setPatientDashboardTileState = function (dashboardTile) {
                if (dashboardTile) {
                    var localSettings = DashboardRepository.getDashboardFeatureList();

                    if (localSettings) {
                        var localSettingsItem = _.find(localSettings, {Id: dashboardTile.Id});

                        if (localSettingsItem) {
                            localSettingsItem.IsCollapsed = dashboardTile.IsCollapsed;
                            DashboardRepository.setDashboardFeatureList(localSettings);
                        }
                    }
                }
            };

            var getPatientDashboardFeatures = function (){
                return DashboardRepository.getDashboardFeatureList();
            };

            var setPatientDashboardFeatures = function (dashboardSettings) {
                DashboardRepository.setDashboardFeatureList(dashboardSettings);
            };

            return {
                loadPatientDashboardFeatures: loadPatientDashboardFeatures,
                getPatientDashboardFeatures: getPatientDashboardFeatures,
                setPatientDashboardFeatures: setPatientDashboardFeatures,
                setPatientDashboardTileState: setPatientDashboardTileState
            };

        }
    ]);